import { Ref, WatchStopHandle } from 'vue';
import BaseService, { getInstance } from '../base-service';
import useLabelLayer from './useLabelLayer';
import { MessagePlugin } from 'tdesign-vue-next';
import WeMapBaseLayer  from '@tlbs/wemap-base-layer';
const REQUESTS = getInstance() || new BaseService();
export default async function useBaseServiceLayer(
  mapInstance: LooseObject,
  layerInfo: Ref<MapLayer<BaseConfig>>,
) {
  if (!layerInfo.value || !layerInfo.value.config) return;
  let unwatchList: WatchStopHandle[] | null = [];
  let baseServiceLayer:(LooseObject) = {};
  baseServiceLayer.serviceLayer = {};
  const { zIndex } = layerInfo.value;
  const { id: serviceId, name } = layerInfo.value.config.data || {};
  if (serviceId && name) {
    baseServiceLayer.serviceLayer = await handleData(mapInstance, serviceId, zIndex, layerInfo.value.config.data || {});
  }
  unwatchList.push(watch(() => layerInfo.value, () => {
    const { id: serviceId, name } = layerInfo?.value?.config?.data || {};
    baseServiceLayer.serviceLayer.unmount?.();
    baseServiceLayer?.serviceLayer?.destroy?.();
    if (serviceId && name) {
      baseServiceLayer.unmount?.();
      baseServiceLayer = useBaseServiceLayer(mapInstance, layerInfo);
    }
  }, { deep: true }));

  baseServiceLayer.unmount = (): void => {
    baseServiceLayer?.serviceLayer?.unmount?.();
    baseServiceLayer?.serviceLayer?.destroy?.();
    baseServiceLayer = {};
    baseServiceLayer.serviceLayer = {};
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };
  return baseServiceLayer;
}

const handleData = async (mapInstance: LooseObject, id: string, zIndex: number, options: LooseObject) => {
  const { id: serviceId, layerName } = options;
  try {
    const serviceInfo = await REQUESTS.getServiceInfo(serviceId);
    const [serviceDetail] = serviceInfo.data || [];
    if (!serviceDetail) {
      MessagePlugin.warning({ content: `拉取${layerName ? layerName : ''}图层失败，数据源已删除` });
      return {};
    }
    const serviceLayer = await drawServiceLayer(mapInstance, { ...serviceDetail, id, serviceId, zIndex }, 'service');
    return serviceLayer;
  } catch (err) {
    console.error(err);
    MessagePlugin.warning({ content: `拉取${layerName ? layerName : ''}图层失败` });
    return {};
  }
};

export async function drawServiceLayer(mapInstance: LooseObject, options: LooseObject, type: string) {
  try {
    const { id, datasourceType, serviceaddress } = options;
    const serviceType = getServiceType(type === 'map' ? datasourceType : serviceaddress);
    console.log(serviceType, id);
    const { dataSource2 } = REQUESTS.getDomain();
    let baseURL = dataSource2?.service?.defaults?.baseURL || 'https://testservice.wemap.qq.com';
    baseURL = `${baseURL}/base`;
    const debug = baseURL.indexOf('test') !== -1;
    if (serviceType === 'geoJson') {
      return new WeMapBaseLayer(mapInstance, {
        httpReq: {
          reqConfig: {
            baseURL,
          } },
        mapProjectId: id,
        debug,
      });
    }
    return new WeMapBaseLayer(mapInstance, {
      httpReq: {
        reqConfig: {
          baseURL,
        } },
      serviceIds: [id],
      debug,
    });
  } catch (err) {
    console.error(err);
  }
}

export function drawLabelLayer(mapInstance: LooseObject, options: LooseObject, layer: LooseObject) {
  const { id, zIndex, layerOrder, layerType, labelStyle, labelField } = options;
  const { data, style } = getLabelData(layerType, labelStyle, labelField, layer) || {};
  const layerMap = reactive<LooseObject>({});
  layerMap[id] = {
    id,
    type: layerType,
    zIndex: (zIndex || 1) + (layerOrder || 1),
    config: {
      data,
      enableCollision: true,
      ...style,
    },
  };
  return useLabelLayer(mapInstance, toRef(layerMap, id));
}
const getLabelData = (layerType: string, style = '{}', labelField = '', layer: LooseObject) => {
  const type = getLayerType(layerType);
  const layerGeometries = layer?._geomtryOverlays[type]?.geometries;
  const data = layerGeometries?.map((geometry: LooseObject) => {
    let position = undefined;
    if (type === 'marker') position = geometry.position;
    if (type === 'polyline') [position] = geometry.paths;
    if (type === 'polygon') position = !Array.isArray(geometry.paths?.[0]) ? TMap.geometry.computeCentroid(geometry.paths) : TMap.geometry.computeCentroid(geometry.paths[0]);
    if (!position) return undefined;
    return {
      id: geometry.id,
      content: geometry?.properties?.[labelField] !== 0 ? String(geometry?.properties?.[labelField] || 'null') : '0',
      position,
      properties: geometry.properties || {},
    };
  });
  return {
    data,
    style: style !== '{}' ? JSON.parse(style) : labelStyle,
  };
};

const getLayerType = (type: string) => {
  const lowerType = type.toLowerCase();
  if (lowerType.indexOf('marker') !== -1 || lowerType.indexOf('point') !== -1) return 'marker';
  if (lowerType.indexOf('line') !== -1) return 'polyline';
  if (lowerType.indexOf('polygon') !== -1) return 'polygon';
  return type;
};

const getServiceType = (type: string) => {
  const lowerType = type.toLocaleLowerCase();
  if (lowerType.indexOf('tif') !== -1 || lowerType.indexOf('wmts') !== -1) return 'wmts';
  if (lowerType.indexOf('wms') !== -1) return 'wms';
  if (lowerType.indexOf('mvt') !== -1) return 'mvt';
  if (lowerType.indexOf('tiles') !== -1) return 'tiles';
  return 'geoJson';
};
